<template>
    <div id="incomeSummaryReport">
        <div :class="`loader${loaderClass}`" v-show="loading"></div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <div class="page-title"> Income Summary Report</div>
                    <a href="javascript:void(0)" class="btn btn-secondary pull-right" v-on:click="exportIncomeSummary()">
                        <i class="fp-export"></i> Export
                    </a>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content income-summary-report">
                        <!-- <div class="FiltersLabel">Filters</div> -->
                        <div id="dataTableFilterConfig" class="border-top-table-fl mb-3">
                            <div class="form-row row-cols-md-4 row-cols-1">
                                <div class="col form-group">
                                    <label class="control-label">Type:</label>
                                    <v-select v-model="selectedFilter" name="selectedFilter" placeholder="Select Filter Type."
                                        label="text"
                                        :options="filterOptionsArr" id="selectedFilter" @input="filterTypeChange($event)">
                                    </v-select>       
                                </div>
                                <div class="col form-group" id="selectedYearSection">
                                    <label class="control-label">Year:</label>
                                    <v-select v-model="selectedYear" name="selectedYear" placeholder="Select Year."
                                            label="text"
                                            :options="taxSummaryYearArr" id="selectedYear">
                                    </v-select>       
                                </div>    
                                <div class="col form-group date-picker-filter hide" id="filterDateRange">
                                    <label class="control-label">Date Range:</label>
                                    <v-md-date-range-picker onkeydown="return false" autocomplete="off" @change="handleChange($event)" show-year-select></v-md-date-range-picker>
                                </div>
                                <div class="col form-group" id="glAccountFilter">
                                    <label class="control-label" for="gl_account">GL Account:</label>
                                    <v-select v-model="gl_account" name="gl_account"
                                        label="text" :filterable="false" :options="revenueAccountsArr"
                                        @search="onSearchGLAccount"
                                        placeholder="Select GL Account" class="custom-ci-auto-search" id="glAccountFilterValue">
                                    <template slot="no-options">
                                        Search GL Account...
                                    </template>
                                    <template slot="option" slot-scope="option">
                                        <div class="d-center">
                                            {{ option.text }}
                                        </div>
                                    </template>
                                    <template slot="selected-option" slot-scope="option">
                                        <div class="selected d-center">
                                            {{ option.text }}
                                        </div>
                                    </template>
                                    </v-select>
                                </div>
                            </div>
                            <div class="btn-groups text-right">
                                <button type="submit" value="Search" class="btn btn-primary" v-on:click="onColumnFilter('load')">
                                    <i class="fp-search"> </i> Search
                                </button>
                                <button type="submit" class="btn btn-tertiary" v-on:click="onColumnFilter('cancel')">
                                    <i class="fp-refresh"> </i> Reset 
                                </button>
                                <button type="button" value="Search" class="btn btn-primary" v-on:click="showList = false">
                                    <i class="fp-scope-rate"> </i>Graph
                                </button>
                                <button type="button" value="Search" class="btn btn-primary" v-on:click="showList = true">
                                    <i class="fp-accounting"> </i>List
                                </button>
                            </div>        
                        </div>
                        <section class="bg-white">
                            <template v-if="!showList">
                                <line-chart v-if="loaded" :chartData="chartData" ref="incomeChart"/>
                            </template>    
                            <template v-if="showList">
                                <div class="table-responsive-sm">
                                    <table aria-describedby="table" id="contact_table" class="table table-sm table-bordered font-1">
                                        <thead>
                                            <tr class="table-primary">
                                                <th>GL Account Code</th>
                                                <th>Account Description</th>
                                                <template v-for="(headerData , ind) in headerArr">
                                                    <th :key="'header'+ind" class="text-right">
                                                        {{ headerData }}
                                                    </th>    
                                                </template>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <template v-if="incomeSummary.length > 0">
                                                <template v-for="(income , key) in incomeSummary">
                                                    <tr :key="'title'+key" v-if="income.gl_account_desc != undefined">
                                                        <td>
                                                            {{income.gl_account_code}}
                                                        </td>
                                                        <td>
                                                            {{income.gl_account_desc}}
                                                        </td>
                                                        <template v-for="(amountData , amtInd) in income.amount">
                                                            <td :key="'amount'+amtInd" class="text-right">
                                                                {{ amountData }}
                                                            </td>    
                                                        </template>    
                                                    </tr>
                                                    <tr :key="'net'+key" v-if="key == incomeSummary.length -1">
                                                        <td class="font-bold"> TOTAL </td>
                                                        <td>&nbsp;&nbsp;</td>
                                                        <template v-for="(netData , ind) in income.net">
                                                            <td :key="'net'+ind" class="font-bold text-right">
                                                                {{ netData }}
                                                            </td>    
                                                        </template>
                                                    </tr>
                                                </template>
                                            </template>    
                                        </tbody>    
                                    </table>
                                </div>
                            </template>    
                        </section>         
                    </div>        
                </div>    
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>    
        </div>    
    </div>    
</template>
<script>
import Vue from 'vue';


import {commonMixins} from '../../../mixins/commonMixins';
import {contractMixins} from '../../../mixins/contractMixins';
import VMdDateRangePicker from "v-md-date-range-picker";
import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css';
import moment from 'moment';
Vue.use(VMdDateRangePicker);
export default {
    name: "IncomeSummaryReport",
    metaInfo: {
      // title will be injected into parent titleTemplate
      title: "Income Summary Report | " +process.env.COPYRIGHT_NAME
    },
    components: {
        lineChart: () => import('@/components/graph/LineChart')
    },
    mixins:[commonMixins,contractMixins],
    data: () => ({
        permissions:[],
        loading:false,
        cantAccessPage:"",
        incomeSummary: [],
        quarterMonths:[],
        dateFilter:{
            filterValue: null,
            filterDateValue: null
        },
        action:"list",
        filterOptionsArr:[
            {text:"Monthly",value:"month"},
            {text:"Quarterly",value:"quarter"},
            {text:"Custom",value:"custom"},
        ],
        selectedYear:"",
        selectedFilter:{text:"Quarterly",value:"quarter"},
        headerArr:[],
        gl_account:"",
        revenueAccountsArr:[],
        type:"R",
        chartData:null,
        loaded:false,
        showList:false
    }),
    watch:{
        permissions: function(permission){
            var self = this;
            permission.forEach(function (permissions) {
                if(permissions.name == 'income_summary_report') {
                    self.cantAccessPage = true;
                }
            });            
        }
    },
    created: function() {
    },
    mounted: function () {

        this.getPermissions();
        var self = this;
        setTimeout(function(){
            $("#filterDateRange .text-field").val("");   
        },300);
        var currentYear = self.getCurrentYear();
        self.selectedYear = { text : currentYear, value: currentYear}
        self.loadExpenseSummary();
    },
    methods:{
        
        onSearchGLAccount(search, loading) {
            var self = this;
            if (search.length > 2) {

                loading(true);
                self.searchField(loading, search, 'revenue accounts', '');
            }
        },
        handleChange (values) {
            this.values = values;
            var selectedDateArr = [];

            for( var i=0; i<values.length; i++ ) {
                selectedDateArr[i] = values[i].format('MM/DD/YYYY');
        
            }
            this.dateFilter.filterDateValue = selectedDateArr;
        },
        filterTypeChange(evt) {
            var self = this;
            $("#filterDateRange .text-field").removeClass('border-red');
            $("#selectedYear .dropdown-toggle").removeClass('border-red');
            $("#selectedFilter .dropdown-toggle").removeClass('border-red');
            self.gl_account = "";
            self.revenueAccountsArr = [];
            if (self.selectedFilter != null) {
                if (self.selectedFilter.value == "custom") {
                    $('#filterDateRange').removeClass("hide");
                    $("#filterDateRange .text-field").val("");
                    self.dateFilter.filterDateValue = [];
                    if (!$('#selectedYearSection').hasClass("hide")) {
                        $('#selectedYearSection').addClass("hide");
                        self.selectedYear = "";    
                    }
                }else {
                    if (!$('#filterDateRange').hasClass("hide")) {
                        $('#filterDateRange').addClass("hide");
                        $("#filterDateRange .text-field").val("");
                        self.dateFilter.filterDateValue = [];
                    }
                    $('#selectedYearSection').removeClass("hide");
                    var currentYear = self.getCurrentYear();
                    self.selectedYear = { text : currentYear, value: currentYear}
                }
            }else{
                if (!$('#filterDateRange').hasClass("hide")) {
                    $('#filterDateRange').addClass("hide");
                    $("#filterDateRange .text-field").val("");
                    self.dateFilter.filterDateValue = [];
                }
                if ($('#selectedYearSection').hasClass("hide")) {
                    $('#selectedYearSection').removeClass("hide");
                    var currentYear = self.getCurrentYear();
                    self.selectedYear = { text : currentYear, value: currentYear}
                }
            }
        },
        loadExpenseSummary() {
            var self = this;
            self.loading = true;

            if (self.selectedFilter.value == "custom") {
                var fields = {
                    type:self.type,
                    year:self.selectedYear.value,
                    filterType:self.selectedFilter.value,
                    dateRange:self.dateFilter.filterDateValue,
                    account:(self.gl_account != undefined && self.gl_account != null && self.gl_account != '') ? self.gl_account.value : "",
                    action:self.action
                };
            }else{
                var fields = {
                    type:self.type,
                    year:self.selectedYear.value,
                    filterType:self.selectedFilter.value,
                    account:(self.gl_account != undefined && self.gl_account != null && self.gl_account != '') ? self.gl_account.value : "",
                    action:self.action
                };
            }
            
            $.ajax({
                url: process.env.ROOT_API + "/accounting/reports/income-expense-summary",
                type: "POST",
                data: fields,
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    // console.log(data);
                    if (data.status == "success") {
                        if (self.action =='export'){

                            self.action = 'list';
                            if ( data.code == "201" ) {
                                alert(data.message);
                            } else {

                                self.excel = data.content.web;
                                var save = document.createElement("a");
                                save.href = self.excel;
                                save.download = data.content.web;
                                save.target = "_blank";

                                document.body.appendChild(save);
                                save.click();
                                document.body.removeChild(save);
                            }
                        }else{
                            self.chartData = {
                                //Data to be represented on x-axis
                                labels: data.content.label,
                                datasets: [
                                    {
                                        label: 'Income',
                                        backgroundColor: '#098de1',
                                        pointBackgroundColor: 'white',
                                        borderWidth: 4,
                                        borderColor:'#098de1',
                                        pointBorderColor: '#249EBF',
                                        //Data to be represented on y-axis
                                        data: data.content.value,
                                        pointRadius:0,
                                        pointHitRadius:4,
                                        fill:false
                                    }
                                ]
                            };
                            self.loaded = true;
                            self.headerArr = data.content.header;
                            self.incomeSummary = data.content.summary;
                        }
                    }else{
                        self.$swal('',data.message,'info');
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR,false,'income-summary-report');
                }
            });
        },
        checkFilterValidation: function() {
            var self = this;
            var error = false;

            if (self.selectedFilter != null) {
                if (self.selectedFilter.value == "custom") {
                    if (self.dateFilter.filterDateValue == null || self.dateFilter.filterDateValue == "" || !self.dateFilter.filterDateValue) {
                        $("#filterDateRange .text-field").addClass('border-red');
                        error = true;
                    }else{
                        $("#filterDateRange .text-field").removeClass('border-red');    
                    }
                }else{
                    if (self.selectedYear == null || self.selectedYear.value == "") {
                        $("#selectedYear .dropdown-toggle").addClass('border-red');
                        error = true;
                    }else{
                        $("#selectedYear .dropdown-toggle").removeClass('border-red');
                    }
                }
            }

            if (self.selectedFilter == null || self.selectedFilter.value == "") {
                $("#selectedFilter .dropdown-toggle").addClass('border-red');
                error = true;
            }else{
                $("#selectedFilter .dropdown-toggle").removeClass('border-red');
            }

            return error;
        },
        onColumnFilter(flag) {
            var self = this;
            if ( flag == 'load' ) {
                var error = false;
                error = self.checkFilterValidation();
                if (!error) {
                    self.loadExpenseSummary();
                }
            }else{
                setTimeout(function(){                   
                    $("#filterDateRange .text-field").val("");
                    $("#filterDateRange .text-field").removeClass('border-red');
                    $("#selectedYear .dropdown-toggle").removeClass('border-red');
                    $("#selectedFilter .dropdown-toggle").removeClass('border-red');
                    $('#filterDateRange').addClass("hide");
                    if ($('#selectedYearSection').hasClass("hide")) {
                        $('#selectedYearSection').removeClass("hide");
                    }
                },200);

                self.dateFilter = {filterValue: null,filterDateValue: null};
                var currentYear = self.getCurrentYear();
                self.selectedYear = { text : currentYear, value: currentYear};
                self.selectedFilter = {text:"Quarterly",value:"quarter"};
                self.gl_account = "";
                self.revenueAccountsArr = [];
                self.loadExpenseSummary();
            }
        },
        getCurrentYear() {
            var today = new Date();
            var yyyy = today.getFullYear();
            return yyyy.toString();
        },
        exportIncomeSummary() {
            var self = this;
            this.action = "export";
            this.loadExpenseSummary();
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/accounting/reports/IncomeSummaryReport.vue